import React from 'react'

import 'browser/components/atomic-elements/atoms/input/_pill-input.scss'
import _ from 'lodash'

interface IPillInputProps {
  onChange: (value: any) => void

  columns?: number
  options: any[]
  optionValuePath?: string
  optionLabelPath?: string
}

interface IPillInputState {
  value?: any
}

export class PillInput extends React.Component<IPillInputProps, IPillInputState> {
  public static defaultProps: Partial<IPillInputProps> = {
    columns: 4,
  }

  private columnsClasses = {
    1: 'c-pillInput-1wide',
    2: 'c-pillInput-2wide',
    3: 'c-pillInput-3wide',
    4: 'c-pillInput-4wide',
  }

  constructor(props) {
    super(props)

    this.state = {

    }
  }

  public render() {
    const { options } = this.props

    if (_.isEmpty(options)) {
      return <></>
    }

    return <div className='c-pillInput'>
      { options.map(this.renderOption) }
    </div>
  }

  public renderOption = (option) => {
    const { optionLabelPath } = this.props
    const optionLabel = optionLabelPath ? _.get(option, optionLabelPath) : option

    return <div
      className={`c-pillInput-optionContainer ${this.getColumnsClass()}`}
      onClick={() => this.selectOption(option)}
    >
      <div className={`c-pillInput-optionValue ${this.getSelectedClass(option)}`}>
        {optionLabel}
      </div>
    </div>
  }

  public getColumnsClass() {
    return this.columnsClasses[this.props.columns]
  }

  public getSelectedClass(option) {
    return _.isEqual(option, this.state.value) ? 'c-pillInput-selected' : ''
  }

  public selectOption(option) {
    const { onChange } = this.props
    const { optionValuePath } = this.props
    const optionValue = optionValuePath ? _.get(option, optionValuePath) : option

    onChange?.(optionValue)

    this.setState({
      value: option
    })
  }
}
